<form *ngIf="onlinePayementInfo" #billPayment="ngForm" (ngSubmit)="onSubmit(billPayment, $event)" method="post" action="{{onlinePayementInfo.action}}" target="_blank">
  <input type="hidden" name="version" value="{{onlinePayementInfo.version}}" />
  <input type="hidden" name="TPE" value="{{onlinePayementInfo.tpe}}" />
  <input type="hidden" name="date" value="{{onlinePayementInfo.date}}" />
  <input type="hidden" name="montant" value="{{onlinePayementInfo.montant}}" />
  <input type="hidden" name="reference" value="{{onlinePayementInfo.reference}}" />
  <input type="hidden" name="MAC" value="{{onlinePayementInfo.mac}}" />
  <input type="hidden" name="url_retour" value="{{onlinePayementInfo.url_retour}}" />
  <input type="hidden" name="url_retour_ok" value="{{onlinePayementInfo.url_retour_ok}}" />
  <input type="hidden" name="url_retour_err" value="{{onlinePayementInfo.url_retour_err}}" />
  <input type="hidden" name="lgue" value="{{onlinePayementInfo.lgue}}" />
  <input type="hidden" name="societe" value="{{onlinePayementInfo.societe}}" />
  <input type="hidden" name="texte-libre" value="{{onlinePayementInfo.textelibre}}" />
  <input type="hidden" name="mail" value="{{onlinePayementInfo.mail}}" />
  <button *ngIf="inInvoice" type="submit" class="btn btn-primary" [ngClass]="{'btn-mobile': isMobile}">
    <i class="fa fa-fw fa-money-bill"></i> {{ 'buttons.pay' | translate }}
  </button>
  <button *ngIf="!inInvoice" type="submit" class="btn btn-sm tooltip tooltip-left" [ngClass]="{'btn-mobile': isMobile}" [attr.data-tooltip]="('buttons.pay' | translate)">
    <i class="fa fa-fw fa-money-bill"></i>
  </button>
</form>